<template lang="pug">
div
  el-card.card-info(:body-style="{ width: '100%' }" shadow="hover")
    el-row(:gutter="40")
      el-col(:span="8")
        b Número do processo:
        | {{ " " + processo.numero }}
      el-col(:span="8")
        b Tipo de processo:
        | {{ " " + processo.tipoCadastro.nome }}
      el-col(:span="8")
        b Nome/Razão social:
        | {{ " " + processo.nomeRazaoSocialInteressado }}

    el-row.margin-top-20(:gutter="40")
      el-col(:span="8")
        b CPF/CNPJ:
        | {{ " " + processo.cpfCnpjInteressado }}
      el-col(:span="8")
        b Telefone:
        | {{ " " + processo.telefone.replace(/,/g, ', ') }}
      el-col(:span="8")
        b E-mail:
        | {{ " " + processo.email.replace(/,/g, ', ') }}

  router-view

</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      processo: {
        numero: null,
        tipoCadastro: '',
        nomeRazaoSocialInteressado: '',
        cpfCnpjInteressado: '',
        telefone: '',
        email: ''
      }
    }
  },

  async created () {
    if (!this.$route.params.numeroProcesso) {
      this.$router.push({ name: 'cof/home' })
      return
    }

    let processo = await this.findProcessoByNumeroProcesso(this.$route.params.numeroProcesso)
    this.processo = processo
  },

  methods: {
    ...mapActions({
      findProcessoByNumeroProcesso: 'cadastroProcessoFisico/findProcessoByNumeroProcesso'
    }),

    botoesAcao () {
      return []
    },

    voltar () {
      this.$router.push({
        name: 'cof/home'
      })
    }
  }
}
</script>

<style scoped>
.card-info {
  border-radius: 15px;
  background-color: #f3f7fa;
  border-color: #eaeef1;
  margin: 2%;

}

.card-vtn {
  border-radius: 15px;
  background-color: white;
  border-color: #009f61;
  color: #b8ebc0;
  margin: 2%;
}

#appArrecadacao .card-vtn p {
  color: #018351;
}

.listagem-daes {
  border-radius: 15px;
  margin: 2%;
}

.card-header {
  display: flex;
  justify-content: space-between;
}

.row-calcular {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.margin-2-por-cento {
  margin: 2%;
}

.margin-top-20 {
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/processoFisico/VisualizarProcessoFisico.vue